module.exports = __webpack_public_path__ + "static/img/p_05.c43478e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_05.jpg
// module id = a+Ps
// module chunks = 9